import { ChangeDetectionStrategy, Component, HostBinding, ViewEncapsulation } from "@angular/core";

@Component({
	selector: "obg-browser-not-supported",
	templateUrl: "./browser-not-supported.component.html",
	styleUrls: ["./browser-not-supported.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
})
export class BrowserNotSupportedComponent {
	@HostBinding("class.obg-browser-not-supported") class = true;

	trackBybrowser(_index: number, browser: string) {
		return browser;
	}

	getBrowserSpecificImageKey(browser: string): string {
		return `general.browser-${browser}`;
	}
}
